export class BuildingSearchResponse {
  public realEstateNames?: RealEstateNames[];
}

export class RealEstateNames {
  public realEstateId?: string;

  public searchableRegion?: SearchableRegion;
}

export class SearchableRegion {
  public municipality?: string;

  public area?: string;

  public postalCode?: string;

  public streetAddress?: string;

  public realEstateName?: string;
}

export default BuildingSearchResponse;
